import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CyclesPanel from "@/components/reviews/CyclesPanel";
import MyFeedback from "@/components/reviews/MyFeedback";
import MyReviews from "@/components/reviews/MyReviews";

export default function PerformancePage() {
  const { user } = useAuth();
  const isMgr = ["admin", "hr_manager", "dept_head"].includes(user.role);
  const hasEmp = !!user.employee_id;

  const tabs = [
    ...(isMgr ? [["cycles", "Review Cycles"]] : []),
    ...(hasEmp ? [["feedback", "My Feedback Requests"], ["reviews", "My Reviews"]] : []),
  ];

  return (
    <div className="space-y-5 fade-in" data-testid="performance-page">
      <Tabs defaultValue={tabs[0]?.[0]}>
        <TabsList className="rounded-none bg-white border border-border h-10 p-0">
          {tabs.map(([v, l]) => (
            <TabsTrigger key={v} value={v} data-testid={`performance-tab-${v}`}
              className="rounded-none h-full px-5 text-[12px] uppercase tracking-wider data-[state=active]:bg-[var(--brand-primary)] data-[state=active]:text-white">
              {l}
            </TabsTrigger>
          ))}
        </TabsList>
        {isMgr && <TabsContent value="cycles" className="mt-4"><CyclesPanel /></TabsContent>}
        {hasEmp && <TabsContent value="feedback" className="mt-4"><MyFeedback /></TabsContent>}
        {hasEmp && <TabsContent value="reviews" className="mt-4"><MyReviews /></TabsContent>}
      </Tabs>
    </div>
  );
}
